<template>
  <div class="col-lg-3 col-md-4">
    <div class="footer-title" @click="toggleMenu">
      <h5>
        {{ _T('Get to Know Us') }}
        <span class="according-menu">
          <svg width="12" height="6" fill="none">
            <use xlink:href="#downArrow" />
          </svg>
        </span>
      </h5>
    </div>
    <ul class="footer-content">
      <li>
        <router-link
          :to="{ name: 'about_us' }"
          v-if="all_static_pages_by_slug_search(CONST.ABOUT_US_SLUG)"
        >
          {{ _T('About') + ' ' }}

          {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order') }}
        </router-link>
      </li>
      <!-- <li>
        <router-link :to="{ name: '' }">{{ _T('Careers') }}</router-link>
      </li>
      <li>
        <router-link :to="{ name: '' }">{{ _T('Blog') }}</router-link>
      </li>
      <li>
        <router-link :to="{ name: '' }">{{ _T('Accessibility') }}</router-link>
      </li> -->
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      openmenu: false,
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'all_static_pages_by_slug_search',
      'domainBasedBrand',
      '_T_DB',
      'currentBrand',
    ]),
  },
  methods: {
    toggleMenu() {
      this.openmenu = !this.openmenu
    },
  },
}
</script>
